/*
 * product-addons.js — Milchstrasse Luzern
 * ---------------------------------------------------------------------------
 * Product-page add-on (Beilagen) up-sell. Works with snippets/product-addons.liquid.
 *
 *  - Keeps a running "extra" subtotal as add-ons are ticked.
 *  - Tapping an add-on thumbnail opens its preview <dialog> (bigger photo,
 *    description, add/remove) — the dialog's button drives the same checkbox.
 *  - On add-to-cart, if any add-ons are selected, adds the box PLUS each selected
 *    add-on to the cart in one /cart/add.js call (add-ons are real line items so
 *    they're charged; each is tagged "Beilage zu: <box>"), then goes to the cart.
 *  - If no add-ons are selected, the theme's normal add-to-cart runs untouched.
 *
 * Event-delegated + scoped to the main product form, so recommendations /
 * quick-add elsewhere on the page are unaffected.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var PICKER = '[data-product-addons]';

  function money(cents) { return 'CHF ' + (cents / 100).toFixed(2); }

  function updateSubtotal(picker) {
    var cents = 0;
    picker.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
      cents += parseInt(cb.dataset.addonPrice, 10) || 0;
    });
    var el = picker.querySelector('[data-addons-subtotal]');
    if (!el) return;
    if (cents > 0) {
      el.textContent = (picker.dataset.subtotalLabel || '') + ' ' + money(cents);
      el.hidden = false;
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  }

  function findAddonCheckbox(dlg, variantId) {
    var picker = dlg.closest(PICKER);
    return picker && picker.querySelector('input[data-variant-id="' + variantId + '"]');
  }

  // Preview dialog: thumbnail opens it, its button toggles the checkbox.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var peek = e.target.closest('[data-addon-peek]');
    if (peek) {
      var dlg = document.getElementById(peek.dataset.addonPeek);
      if (!dlg || typeof dlg.showModal !== 'function') return;
      var toggle = dlg.querySelector('[data-addon-dialog-toggle]');
      if (toggle) {
        var cb = findAddonCheckbox(dlg, toggle.dataset.addonDialogToggle);
        toggle.textContent = cb && cb.checked ? toggle.dataset.labelRemove : toggle.dataset.labelAdd;
      }
      dlg.showModal();
      return;
    }

    var close = e.target.closest('[data-addon-dialog-close]');
    if (close) {
      var d = close.closest('dialog');
      if (d) d.close();
      return;
    }

    var tog = e.target.closest('[data-addon-dialog-toggle]');
    if (tog) {
      var dlg2 = tog.closest('dialog');
      var cb2 = dlg2 && findAddonCheckbox(dlg2, tog.dataset.addonDialogToggle);
      if (cb2) {
        cb2.checked = !cb2.checked;
        cb2.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (dlg2) dlg2.close();
      return;
    }

    // The whole row toggles the add-on. The thumbnail remains a separate
    // preview action (handled above), while direct checkbox activation is left
    // native so keyboard and assistive-technology interaction stays intact.
    var item = e.target.closest('.product-addons__item');
    if (item) {
      var itemCheckbox = item.querySelector('input[type="checkbox"]');
      if (!itemCheckbox || e.target === itemCheckbox) return;
      e.preventDefault();
      itemCheckbox.checked = !itemCheckbox.checked;
      itemCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    // Click landed on the <dialog> element itself = the backdrop (the body div
    // covers the whole dialog, so real content clicks never target the dialog).
    if (e.target.matches && e.target.matches('dialog.product-addons__dialog')) e.target.close();
  });

  // Selected style + running subtotal.
  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb.matches || !cb.matches(PICKER + ' input[type="checkbox"]')) return;
    var item = cb.closest('.product-addons__item');
    if (item) item.classList.toggle('product-addons__item--on', cb.checked);
    updateSubtotal(cb.closest(PICKER));
  });

  // Add box + selected add-ons together (capture → before the theme's handler).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.querySelector || !form.querySelector('[name="id"]')) return; // not a product form
    var area = form.closest('[data-section-type="product-template"]');
    if (!area) return;                                   // only the main product form
    var picker = area.querySelector(PICKER);
    if (!picker) return;                                 // this product has no add-ons
    var checked = picker.querySelectorAll('input[type="checkbox"]:checked');
    if (!checked.length) return;                         // none selected → let the theme add the box

    e.preventDefault();
    e.stopImmediatePropagation();

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var boxTitle = picker.dataset.boxTitle || '';
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');

    var items = [{ id: idInput.value, quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1 }];
    checked.forEach(function (cb) {
      items.push({ id: cb.dataset.variantId, quantity: 1, properties: { 'Beilage zu': boxTitle } });
    });

    var btn = form.querySelector('[type=submit][name=add]');
    if (btn) btn.setAttribute('disabled', 'disabled');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.body && res.body.description) || 'cart/add failed');
        window.location = root + 'cart';
      })
      .catch(function (err) {
        if (btn) btn.removeAttribute('disabled');
        console.warn('[product-addons] could not add to cart:', err && err.message);
      });
  }, true);
})();
